<template>
    <Modal
        :title="'Deneme Sürümünü Atla'"
        @ok="confirm"
        @cancel="close"
        :cancel-text="'Vazgeç'"
        :ok-text="'Onayla'"
        :show-footer="true"
    >
        <div>Deneme sürümünü atlayarak, işletmenize uygun paketi seçerek devam edebilirsiniz. Deneme sürümünü atlarsanız, bu işlem geri alınamaz.</div>
    </Modal>
</template>
<script>
import Modal from "../../../../components/common/Modal2.vue";

export default {
    name: "TrialSkipModal",
    components: {
        Modal,
    },
    methods: {
        close() {
            this.$emit("reject");
        },
        confirm() {
            this.$emit("confirm");
        },
    },
};
</script>
